// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import { RCPopover } from '@reverbdotcom/cadence/components';
import FilterChip from '@reverbdotcom/commons/src/components/filter_chip';
import SelectFacet from '@reverbdotcom/commons/src/components/select_facet';
import { ProductReviewFilterFields } from '@reverbdotcom/commons/src/gql/graphql';
import React from 'react';
import { isSomethingSelected } from '@reverbdotcom/commons/src/facet_utils';

interface Props {
  filter: ProductReviewFilterFields.Fragment;
  loading: boolean;
}

export function ProductReviewFilter(props: Props) {
  const [popoverIsOpen, openPopover] = React.useState(false);

  if (!props.filter) {
    return null;
  }

  const selectedFilterOptions = props.filter.options?.filter(f => {
    return f.selected;
  });

  const buttonText = () => {
    if (selectedFilterOptions?.length === 0 || selectedFilterOptions?.length >= 2) return props.filter.name;

    return `${props.filter.name}: ${selectedFilterOptions[0].name}`;
  };

  return (
    <div className="mlr-2">
      <RCPopover
        isOpen={popoverIsOpen}
        onDismiss={() => openPopover(false)}
        position="bottom-start"
        loading={props.loading}
        anchor={
          <FilterChip
            withDropdown
            loading={props.loading}
            selected={isSomethingSelected(props.filter)}
            onClick={() => openPopover(!popoverIsOpen)}
            count={selectedFilterOptions.length}
          >
            {buttonText()}
          </FilterChip>
        }
      >
        <SelectFacet
          pageSection="filter-row"
          filter={props.filter}
        />
      </RCPopover>
    </div>
  );
}

export const ProductReviewFilterFragment = gql`
  fragment ProductReviewFilterFields on reverb_search_Filter {
    name
    key
    widgetType
    options {
      count {
        value
      }
      name
      selected
      paramName
      setValues
      unsetValues
      optionValue
    }
  }
`;
